import { render, staticRenderFns } from "./ProductOutfitDetail.vue?vue&type=template&id=47ec9de9&"
import script from "./ProductOutfitDetail.vue?vue&type=script&lang=js&"
export * from "./ProductOutfitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports